
<ng-container *ngIf="!loading">
    <ng-container *ngIf="trans_key">
        <app-dcintrac-send-successful></app-dcintrac-send-successful>
    </ng-container>
    <ng-container *ngIf="!trans_key && payment_source_success">
        <app-payment-success-qr></app-payment-success-qr>
    </ng-container>
    <ng-container *ngIf="!trans_key && !payment_source_success">
        <ng-container class="container-fluid" *ngIf="isSuccessful">
            <div class="row pl-1 pl-md-5 pt-5 m-0">
                <div class="col-md-4">
                    <div class="container send-money head-top px-0" >
                        
                        <div class="heading-text">Your money is on it’s way!</div>
                        
                            <div class="secondary-text sm-12 mobile16 mb-3">
                                Your transfer to {{ recvName.toUpperCase() }} is in progress.
                                We’ll update you when it’s complete - but you can track the progress of
                                your transaction from the home tab. 
                            </div>
                            <button  (click)="goToHome()" routerLinkActive="router-link-active"   type="button" class="btn btn-primary px-5">
                                Return home
                            </button>
                            <!-- <div *ngIf="auth.user?.country_id==233 && sendMoneyService.usa_trans_details">

                                <div class="col-12 py-3 d-flex flex-wrap align-items-center px-0">
                                    <div class="py-1 col-12 text-center reciept_heading">Receipt</div>
                                    <div class="py-1 col-7 col-md-8">Sender:</div>
                                    <div class="py-1 col-5 col-md-4">{{ auth.user.name }} {{auth.user.lastname || ''}}</div>
                                    <div class="py-1 col-7 col-md-8">Send amount:</div>
                                    <div class="py-1 col-5 col-md-4">$ {{ sendMoneyService.usa_trans_details.sender_amount }}</div>
                                    <div class="py-1 col-7 col-md-8">Fee paid by sender:</div>
                                    <div class="py-1 col-5 col-md-4">$ {{ sendMoneyService.usa_trans_details.fee_amount }}</div>
                                    <div class="py-1 col-7 col-md-8">Total amount from sender:</div>
                                    <div class="py-1 col-5 col-md-4">$ {{ sendMoneyService.usa_trans_details.sender_amount+sendMoneyService.usa_trans_details.fee_amount }}</div>
                                    <div class="py-1 col-7 col-md-8">Funding account:</div>
                                    <div class="py-1 col-5 col-md-4">{{ sendMoneyService.usa_trans_details.funding_source }}</div>
                                    <div class="py-1 col-7 col-md-8">Recipient:</div>
                                    <div class="py-1 col-5 col-md-4">{{ recvName.toUpperCase() }}</div>
                                    <div class="py-1 col-7 col-md-8">Recipient account instructions:</div>
                                    <div class="py-1 col-5 col-md-4">{{ sendMoneyService.usa_trans_details.payout_method }}</div>
                                    <div class="py-1 col-7 col-md-8">Recipient reciept amount:</div>
                                    <div class="py-1 col-5 col-md-4">{{ sendMoneyService.usa_trans_details.recipient_amount }} {{ sendMoneyService.usa_trans_details.recipient_currency }}</div>
                                    <div class="py-1 col-7 col-md-8">Expected availability in resipient bank account:</div>
                                    <div class="py-1 col-5 col-md-4">within 2-3 days</div>
                                    <div class="py-1 col-7 col-md-8">Exchange rate:</div>
                                    <div class="py-1 col-5 col-md-4">$1 = {{ sendMoneyService.usa_trans_details.exchange_rate }} {{ sendMoneyService.usa_trans_details.recipient_currency }}</div>
                                    <div class="py-1 col-7 col-md-8">Reference number:</div>
                                    <div class="py-1 col-5 col-md-4">{{ sendMoneyService.usa_trans_details.reference_number }}</div>
                                </div>
                            </div> -->
                            <div *ngIf="auth.user?.country_id==233 && sendMoneyService.usa_trans_details" class="col-12 mt-2">
                                <div class="py-3 col-12 text-center reciept_heading">Receipt</div>
                                <iframe [src]="pdfUrl" width="100%" height="500px"></iframe>
                                
                            </div>
                        </div>
                </div>
                
            </div>
        </ng-container>
        <ng-container *ngIf="!isSuccessful" class="container-fluid">
            <div class="row pl-5 pt-5 m-0">
                <div class="col-md-4">
            <div class="container-fluid send-money" style="padding:5%;">
                
            <div class="heading-text text-danger">Transaction failed</div>
            
            <div class="secondary-text sm-12 mobile16 mb-3">
                Your transfer failed due to an error.
            </div>
            
                <button  (click)="goToHome()" routerLinkActive="router-link-active"   type="button" class="btn btn-primary px-5">Return home</button>
            </div>
            </div>
            </div>
        </ng-container>
    </ng-container>
</ng-container>